import { render, staticRenderFns } from "./NewProviderNotifyModal.vue?vue&type=template&id=1cade3c6&scoped=true&"
import script from "./NewProviderNotifyModal.vue?vue&type=script&lang=ts&"
export * from "./NewProviderNotifyModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewProviderNotifyModal.vue?vue&type=style&index=0&id=1cade3c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cade3c6",
  null
  
)

export default component.exports